export const IGNORED_SETTINGS_KEYS = ['published', 'primaryColorRgb']
